<div class="container">
  <div class="card px-0">
    <div class="card-body">
      <div class="col-12" style="align-items: center">
        <div class="alert alert-info" role="alert">
          <h4 class="alert-heading">
            Bienvenido al Módulo Gestión de Usuario
          </h4>
          <hr />
          <p>
            Presione el botón "Agregar" para crear un usuario comprador o para
            una carga masiva de usuario descargue el archivo excel de ejemplo (
            <a [href]="config.sampleFiles.customerUploadFile" target="_blank"
              ><i
                class="fa-solid fa-file-excel"
                style="margin-left: 5px; margin-right: 5px; font-size: 20px"
              ></i>
              aquí</a
            >
            ) y complete la información, a continuación seleccione el archivo
            modificado y haga clic en el botón con el icono
            <i
              class="fas fa-file-upload"
              style="margin-left: 5px; margin-right: 5px; font-size: 20px"
            ></i>
            que aparecerá continuación .
          </p>
        </div>

        <div class="row">
          <div class="col-sm-4" (click)="crearUsuario()">
            <div class="btn btn-success">
              Agregar
              <i class="far fa-plus-circle" style="margin-left: 10px"></i>
            </div>
          </div>
          <div class="col-sm-4">
            <label [for]="idArchivo" class="btn btn-outline-dark me-2"
              >Seleccionar Archivo
              <i class="fas fa-folder" style="margin-left: 10px"></i
            ></label>
            <input
              type="file"
              #idArchivoInput
              [id]="idArchivo"
              (change)="onFileChange($event)"
              style="display: none"
            />
          </div>
        </div>
      </div>

      @if (archivo) {
      <hr />
      <div class="alert alert-success" role="alert">
        <i
          class="fas fa-file-excel"
          style="margin-right: 10px; font-size: 20px; color: green"
        ></i>
        El archivo <strong>{{ archivo.nombre }}</strong> puede proceder a
        subirlo precione el icono
        <button
          (click)="uploadFile()"
          class="btn btn-primary"
          style="margin-left: 10px"
        >
          <i
            class="fas fa-file-upload"
            style="cursor: pointer; font-size: 20px"
          ></i>
        </button>
      </div>
      @if (nuevo.length) {
      <div
        class="alert alert-success alert-dismissible fade show"
        role="alert"
      >
        <ul>
          @for (item of nuevo; track $index) {
          <li>
            Usuario <strong>{{ item.username }}</strong> ingreso correctamente
            <i
              class="far fa-check-circle"
              style="margin-left: 10px; font-size: 20px; color: green"
            ></i>
          </li>
          }
        </ul>
        <button
          type="button"
          class="btn-close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      } @if (existe.length) {
      <div
        class="alert alert-warning alert-dismissible fade show"
        role="alert"
      >
        <ul>
          @for (item of existe; track $index) {
          <li>
            ¡Usuario <strong>{{ item.username }}</strong> ya existe en la
            tabla!
            <i
              class="far fa-info-circle"
              style="margin-left: 10px; font-size: 20px"
            ></i>
          </li>
          }
        </ul>
        <button
          type="button"
          class="btn-close"
          data-dismiss="alert"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      } }

      <hr />
      <app-tabla-usuario [userSession]="session" />
    </div>
  </div>
</div>
